import React from "react";
import { Select } from "antd";
import { SelectWrapper } from "./style";
import Label from "../style";

const { Option } = Select;

export default ({ options, label, ...rest }) => (
  <SelectWrapper {...rest}>
    <div>
      <Label title={label} />
    </div>
    <Select defaultValue="Kategoriya tanlang" {...rest}>
      {options?.map((option, i) => (
        <Option key={i} value={option.value}>
          {option?.label}
        </Option>
      ))}
    </Select>
  </SelectWrapper>
);
